// Package Imports
import { SvgIcon } from "@mui/material";
// SVG Imports
import LogoSVG from "@/svgs/pulse_prime_logo.svg?react";

const NotFound = () => {
  return (
    <div
      className="pulse-sidenav-adjusted-container pulse-bg-color--background-800"
      style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <SvgIcon
        sx={{
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
        }}
        children={<LogoSVG className="pulse-color--background-900" />}
      />

      <p
        className="pulse-color--background-100 pulse-typography-headline-3"
        style={{
          justifySelf: "center",
          alignSelf: "center",
          zIndex: 1,
        }}
      >
        404. Page not found.
      </p>
    </div>
  );
};

export default NotFound;
